'use client';

export { default } from './ListItemSecondaryAction';
export { default as listItemSecondaryActionClasses } from './listItemSecondaryActionClasses';
export * from './listItemSecondaryActionClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ListItemSecondaryAction/index.js
// module id = 547
// module chunks = 25